module.exports = __webpack_public_path__ + "img/lineing.6f260d4f.png";